import React from "react"
import { ExecutiveTeamWrapper } from "./ExecutiveTeam.styles"
import { Container, Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import TeamMember from "../TeamMember/TeamMember"
import TeamImage from "./TeamImage"
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets"

function useTeamMembers() {
  const data = useStaticQuery(graphql`
    query ExecutiveTeamQuery {
      statamic {
        entries(collection: "team_members", sort: "order", limit: 100) {
          data {
            id
            ... on Statamic_Entry_TeamMembers_TeamMember {
              name
              position
              description
              linkedin_link
              previously_worked_as
              image {
                url
                permalink
              }
            }
          }
        }
      }
    }
  `)

  const entries = data?.statamic?.entries?.data || []
  return entries
    .filter(e => e && e.name && e.image && (e.image.permalink || e.image.url))
    .map(e => {
      const base = prefixStatamicAssetUrl(e.image.permalink || e.image.url)
      const imageUrl = base ? `${base}${base.includes("?") ? "&" : "?"}w=460` : ""
      return {
        name: e.name,
        position: e.position,
        description: e.description || "",
        linkedinLink: e.linkedin_link || null,
        previouslyWorkedAs: e.previously_worked_as || [],
        imageUrl,
      }
    })
}

const ExecutiveTeam = () => {
  const teamMembers = useTeamMembers()

  return (
    <ExecutiveTeamWrapper className="pt-5 px-0">
      <Container className="px-lg-0 px-3 mt-xl-5 mt-lg-3">
        <h2 className="h1 font-weight-bold ambit color-sky-blue text-center text-md-left">EXECUTIVE MANAGEMENT TEAM</h2>
        <p className="text-white h4 mb-5 mt-3 font-weight-light ambit text-center text-md-left meet-the-team">Meet the executives guiding us to success at <strong className="font-weight-bold">APEXX Global</strong></p>
        <Row>
          {teamMembers.map((teamMember) => (
            <Col xs={12} sm={8} md={6} lg={4} key={teamMember.name} className="mb-4 mx-auto mx-md-0 team-member-item">
              <TeamMember teamMember={teamMember} />
            </Col>
          ))}
        </Row>
      </Container>
      <div className="hero-image w-100 p-lg-5 pt-5 mb-5 px-lg-0 px-3">
        <Container>
          <TeamImage/>
        </Container>
      </div>
    </ExecutiveTeamWrapper>
  )
}

export default ExecutiveTeam
